export default __webpack_public_path__ + "static/media/icon-awesome-spinner.15c98776.svg";